import { ThemeProvider, extendTheme } from '@chakra-ui/react';
import { brandThemes, useThemeMode } from 'pixelize-design-library';
import { useMemo, type ReactNode } from 'react';

import { appAccentPalette } from './appAccentPalette';

/** Layers the new brand accent onto the active brand/mode, app-wide. Auth pages override further via AuthThemeScope. */
export function AppAccentScope({ children }: { children: ReactNode }) {
  const { brand, resolvedMode } = useThemeMode();
  const theme = useMemo(
    () =>
      extendTheme(brandThemes[brand][resolvedMode], {
        colors: appAccentPalette(brand)[resolvedMode]
      }),
    [brand, resolvedMode]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
